import React, {ReactNode} from "react";
import {Navigate} from "react-router-dom";

type Props = {
  isLoggedIn: boolean;
  showBreadTitle?: boolean;
  children: ReactNode;
};

function ProtectedRouteComponent({
                                   children, isLoggedIn,
                                 }: Props) {
  if (!isLoggedIn) {
    return (<Navigate to="/auth/login" replace />);
  }
  
  return children;
}

export default ProtectedRouteComponent;
